import { render } from "./Call.vue?vue&type=template&id=1842c80c&scoped=true&bindings={\"phoneNumber\":\"props\",\"makeCall\":\"options\",\"contactUs\":\"options\"}"
import script from "./Call.vue?vue&type=script&lang=js"
export * from "./Call.vue?vue&type=script&lang=js"

import "./Call.vue?vue&type=style&index=0&id=1842c80c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1842c80c"

export default script